import React from "react";
import Container from "../common/Container";
import { HiCheck, HiClock, HiSparkles } from "react-icons/hi";

const roadmapData = [
  {
    period: "Q3 - Q4 2024",
    title: "MVP",
    status: "completed",
    items: [
      "Smart contract development",
      "NFT Crowdfunding",
      "Knowledge base and documentation",
      "UI Development",
      "Results publication",
    ],
  },
  {
    period: "2025",
    title: "VERSION 1.0",
    status: "completed",
    items: [
      "Beta release, early access",
      "Cross-Chain Compatibility",
      "Rewards and royalties",
      "NFT based access control",
      "B2B Marketing",
    ],
  },
  {
    period: "2026",
    title: "VERSION 2.0",
    status: "in-progress",
    items: [
      "Tokenomics (Possible AirDrop!!!)",
      "DAO governance",
      "Reputation system",
      "Research liquidity pools",
      "Gamification and personalized XP",
      "NFT Fractionalization",
      "Subscription based support",
    ],
  },
  {
    period: "Soon Enough 😉",
    title: "PROSPECTS",
    status: "future",
    items: [
      "Campaign manager",
      "Digital twins",
      "AI project matching",
      "Blockchain transparency features",
      "Advanced fundraising options",
      "Scientific awards and certifications",
      "Charity fund",
    ],
  },
];

const RoadmapCard = ({ milestone, index }) => {
  const getStatusIcon = () => {
    switch (milestone.status) {
      case "completed":
        return <HiCheck className="text-primary-green" size={20} />;
      case "in-progress":
        return <HiClock className="text-primary animate-pulse" size={20} />;
      default:
        return <HiSparkles className="text-white/50" size={20} />;
    }
  };

  const getStatusColor = () => {
    switch (milestone.status) {
      case "completed":
        return "from-primary-green to-[#0dcada]";
      case "in-progress":
        return "from-primary to-[#7e7cff]";
      default:
        return "from-gray-500 to-gray-600";
    }
  };

  return (
    <div className="relative group">
      {/* Timeline connector */}
      {index < roadmapData.length - 1 && (
        <div className="hidden lg:block absolute top-10 left-[calc(100%+1rem)] w-8 h-0.5 bg-gradient-to-r from-white/20 to-transparent"></div>
      )}
      
      <div className={`bg-white/5 backdrop-blur-md rounded-2xl p-6 border border-white/10 hover:border-primary/30 transition-all duration-300 hover:shadow-lg hover:shadow-primary/10 h-full ${
        milestone.status === "in-progress" ? "ring-2 ring-primary/30" : ""
      }`}>
        {/* Status Badge */}
        <div className="flex items-center justify-between mb-4">
          <span className={`px-3 py-1 rounded-full text-xs font-medium bg-gradient-to-r ${getStatusColor()} text-white`}>
            {milestone.period}
          </span>
          {getStatusIcon()}
        </div>
        
        {/* Title */}
        <h3 className="text-xl font-bold text-white mb-4 abel-font">
          {milestone.title}
        </h3>
        
        {/* Items */}
        <ul className="space-y-2">
          {milestone.items.map((item, idx) => (
            <li key={idx} className="flex items-start gap-2 text-white/70 text-sm">
              <span className={`w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0 ${
                milestone.status === "completed" ? "bg-primary-green" : 
                milestone.status === "in-progress" ? "bg-primary" : "bg-white/30"
              }`}></span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const RoadmapSection = () => {
  return (
    <section className="w-full py-20 lg:py-28 bg-gradient-to-b from-secondary via-[#1a1230] to-secondary relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/10 via-transparent to-transparent pointer-events-none"></div>
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary-green/30 to-transparent"></div>
      <div className="absolute top-1/4 -right-40 w-96 h-96 bg-primary/5 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-1/4 -left-40 w-80 h-80 bg-primary-green/5 rounded-full blur-[100px] pointer-events-none"></div>
      
      <Container className="relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-primary/20 text-primary-green text-sm font-medium mb-4 border border-primary/20">
            Our Journey
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white abel-font mb-4">
            Looking Ahead
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto text-lg">
            Our roadmap to revolutionizing scientific research funding through blockchain technology.
          </p>
        </div>
        
        {/* Roadmap Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {roadmapData.map((milestone, index) => (
            <RoadmapCard key={index} milestone={milestone} index={index} />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default RoadmapSection;
